import { render } from "./NoTinField.vue?vue&type=template&id=c55928c4&scoped=true&ts=true"
import script from "./NoTinField.vue?vue&type=script&lang=ts"
export * from "./NoTinField.vue?vue&type=script&lang=ts"

import "./NoTinField.vue?vue&type=style&index=0&id=c55928c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c55928c4"]])

export default __exports__